import { Button } from "@/components/button";
import { FONT, MEDIA } from "@/styles/common";
import { Box, Center, Divider, Flex, Img, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import { type FooterProps } from "./types";

export const Footer = ({ logoUrl, isPrivate, pensionInfo, ybs }: FooterProps) => {
    const { isTablet } = MEDIA();

    return (
        <S.Wrapper>
            <Center
                w={isTablet ? "100%" : "1184px"}
                justifyContent={isTablet ? "center" : "space-evenly"}
                rowGap={isTablet ? "24px" : ""}
                flexDir={isTablet ? "column" : "row"}
            >
                <Flex flexDir="column" rowGap="16px" textAlign="center" w="320px">
                    <Text fontFamily="Cormorant" fontWeight="700" fontSize="20px">
                        PENSION INFO
                    </Text>
                    <Box className="pension_detail_info">
                        <Center columnGap="8px">
                            <Text>상호 : {pensionInfo?.name.kr}</Text>
                            {ybs && <Link to={`${ybs}`}>YBS</Link>}
                        </Center>
                        <Text>주소 : {pensionInfo?.address}</Text>
                        <Text>사업자 번호 : {pensionInfo?.bizNumber}</Text>
                    </Box>
                </Flex>
                {!isTablet && <Divider orientation="horizontal" w="auto" h="100px" border="1px solid gray" />}
                <Flex flexDir="column" rowGap="32px" alignItems="center" w="320px">
                    <Img src={logoUrl} w="184px" h="60px" />
                    <Text fontSize="14px">Copyright(C) 2022 MarginMax All Right Reserved</Text>
                </Flex>
                {!isTablet && <Divider orientation="horizontal" w="auto" h="100px" border="1px solid gray" />}
                <Flex flexDir="column" rowGap="16px" textAlign="center" w="320px">
                    <Text fontFamily="Cormorant" fontWeight="700" fontSize="20px">
                        NUMBER INFO
                    </Text>
                    <Flex flexDir="column" rowGap="24px">
                        {isPrivate && (
                            <Box className="pension_private_info">
                                <Text>전화 : {pensionInfo?.phoneNumber}</Text>
                                <Text>계좌번호 : {pensionInfo?.account}</Text>
                            </Box>
                        )}
                        <Button size="tiny" border="none">
                            <Link to="http://marginmax.me/login">관리자 로그인</Link>
                        </Button>
                    </Flex>
                </Flex>
            </Center>
        </S.Wrapper>
    );
};

const Wrapper = styled.footer`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px 0;
    border-top: 1px solid ${({ theme }) => theme.COLOR.text[300]};

    & .pension_detail_info p,
    a {
        ${FONT("pretendard", 14, 300)}
    }

    & .pension_private_info > p {
        ${FONT("pretendard", 14, 300)}
    }
`;

const S = { Wrapper };
